export default {
  data() {
    return {
      verifyAccount: null,
      verifyPassword: null,
      verifyName: null,
      verifyEmail: null,
      verifyPhone: null,
      verifySeniority: null,
      verifyIntroduction: null,
      verifyOldPassword: null,
      verifyNewPassword: null,
      verifyConfirmPassword: null
    };
  },
  methods: {
    //表單驗證，null 表示驗證通過， false 表示驗證失敗格式有誤
    hasValue(val) {
      return val !== "" ? null : false;
    },
    accountRegexp(val) {
      //英文或數字或底線「-」、「_」
      let regex = /^[\w-]*$/;
      let result = val.match(regex);
      if (!result) return false;
      else return null;
    },
    passwordRegexp(val) {
      //8 ~ 24 個大小寫英文或數字
      let regex = /[A-Za-z0-9]{8,24}/;
      let result = val.match(regex);
      if (!result) return false;
      else return null;
    },
    emailRegexp(val) {
      // eslint-disable-next-line no-useless-escape
      let regex = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
      let result = val.match(regex);
      if (!result) return false;
      else return null;
    },
    phoneRegexp(val) {
      //09 開頭，後面是任意 8 個數字結尾
      let regex = /^09\d{8}$/;
      let result = val.match(regex);
      if (!result) return false;
      else return null;
    },
    introductionRegexp(val) {
      //抓到 script tag，正則範例：https://www.regextester.com/96300
      let regex = /<script/gi;
      // val 有可能是 null，因為自我介紹欄位非必填
      let result = !val ? null : val.match(regex);
      if (!result) return null;
      // 沒有匹配到表示驗證通過
      else return false; // 匹配到表示驗證不通過
    },
    isSameInPassword(pwd, confirmPwd) {
      return pwd === confirmPwd ? null : false;
    }
  }
};
